export function isVisibleMaker(makerId: string | number, userEmail: string): boolean {
  const email = (userEmail || "").toLowerCase();
  const isAndDineUser = /@anddine\.co\.uk$/.test(email);
  const testMakerIds = [
    "78f6dcdf-de74-48c9-8f67-ec08cc0f78e0",
    "9f4a8647-4a48-4307-9f05-600fd8d071b0",
  ];

  if (isAndDineUser) return true;
  return !testMakerIds.includes(String(makerId));
}
